import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { isValidWhereToPayTab } from "Components/WhereToPay/WhereToPayTabs/config";
import { WhereToPayTabs } from "Components/WhereToPay/WhereToPayTabs/WhereToPayTabs";
import { useSearchParams } from "Navigation/useSearchParams";
import { Resources, useResource } from "Translations/Resources";

export const WhereToPayPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.WhereToPay)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: null,
      }}
    >
      <StyledPageWrapper>
        <WhereToPayPageContent />
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

const WhereToPayPageContent = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get("activeTab");
  const activeTab = isValidWhereToPayTab(tabParam) ? tabParam : "shops";

  return (
    <div className="left-content">
      <WhereToPayTabs
        initialTab={activeTab}
        onTabChange={(id) => setSearchParams({ activeTab: id })}
      />
    </div>
  );
};

export default WhereToPayPage;
